<template>
    <main-layout>
        <div class="d-flex justify-content-between" slot="header">
            <h2>{{ $t('user.edit') }}</h2>
            <router-link to="/user/new">
                <el-button type="primary" size="small">{{ $t('user.addnew') }}</el-button>
            </router-link>
        </div>
        <div class="page-section">
            <el-form label-width="160px" size="medium">
                <el-form-item :label="$t('user.avatar')">
                    <div class="img-60" @click="chooseAvatar">
                        <img :src="user.avatar" class="img-60" v-if="user.avatar" alt=""/>
                        <div class="img-60 img-placeholder" v-else></div>
                    </div>
                    <div class="el-form-tips">{{ $t('user.avatar_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.nickname')">
                    <el-input class="w300" v-model="user.nickname" autocomplete="off"/>
                    <div class="el-form-tips">{{ $t('user.nickname_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.password')">
                    <el-input class="w300" type="password" v-model="user.password" autocomplete="off"/>
                    <div class="el-form-tips">{{ $t('user.password_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.email')">
                    <el-input class="w300" v-model="user.email"/>
                    <div class="el-form-tips">{{ $t('user.email_tips') }}</div>
                </el-form-item>
                <el-form-item :label="$t('user.role')">
                    <el-select size="medium" class="w300" v-model="user.role_id">
                        <el-option :value="0" label="Please Select"/>
                        <el-option
                            v-for="(role,k) in roles"
                            :label="role.name"
                            :value="role.id"
                            :key="k"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="Buildium Account ID">
                    <el-input class="w300" v-model="user.buildium_account_id" :auto-complete="false"/>
                </el-form-item>
                <el-form-item label="Signature">
                    <div class="img-60" @click="chooseSign">
                        <img :src="meta_data.sign" class="img-60" v-if="meta_data.sign" alt=""/>
                        <div class="img-60 img-placeholder" v-else></div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" type="primary" @click="onSubmit">{{ $t('common.submit') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <media-dialog v-model="showMediaDialog" :options="{width:500,fit:true,type:'image'}" @confirm="onChooseImage"/>
    </main-layout>
</template>

<script>
import UserService from "../utils/UserService";
import ApiService from "../utils/ApiService";

export default {
    name: "UserEdit",
    data() {
        return {
            user: {
                id: '',
                nickname: '',
                avatar: '',
                email: '',
                password: '',
                role_id: 0,
                buildium_account_id: ''
            },
            meta_data: {},
            roles: [],
            showMediaDialog: false,
            loading: false,
            onChooseImage(){}
        }
    },
    methods: {
        fetchData() {
            let {id} = this.$route.params;
            if (id) {
                UserService.getUser(id).then(response => {
                    this.user = {
                        ...this.user,
                        ...response.data
                    };
                    this.meta_data = response.data.metas.reduce((acc, cur) => {
                        acc[cur.meta_key] = cur.meta_value;
                        return acc;
                    }, {});
                });
            }
        },
        fetchRoles() {
            ApiService.get('/users/roles').then(response => {
                this.roles = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {

            });
        },
        onSubmit() {
            let {user} = this;
            if (!user.nickname) {
                this.$message.error(this.$t('user.nickname_required'));
                return false;
            }
            // Only send meta_data (key=>value map). Never send `metas` (array of
            // UserMeta rows) because legacy backend iterators will JSON-encode
            // each row into meta_value and corrupt the data.
            const payload = {...user, meta_data: this.meta_data};
            delete payload.metas;

            this.loading = true;
            if (user.id) {
                UserService.updateUser(user.id, payload).then(() => {
                    this.$message.success(this.$t('user.updated'));
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                UserService.storeUser(payload).then(res => {
                    this.$message.success(this.$t('user.saved'));
                    this.$router.replace('/user/edit/' + res.data.id);
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        chooseAvatar() {
            this.onChooseImage = (m) => {
                this.user.avatar = m.src;
            };
            this.showMediaDialog = true;
        },
        chooseSign() {
            this.onChooseImage = (m) => {
                this.meta_data.sign = m.src;
            };
            this.showMediaDialog = true;
        },
    },
    mounted() {
        this.fetchData();
        this.fetchRoles();
    },
}
</script>

<style scoped>

</style>
